import usePermission from './usePermission';

const tradePermissionName = 'trade';

const useTradePermission = (): boolean => usePermission(tradePermissionName);

export default useTradePermission;
